//@flow
import * as Immutable from 'immutable';

import { LocaleConfigResponse } from 'container/modules/LocaleConfigFetcher/models/flow/LocaleConfigResponse';
// eslint-disable-next-line max-len
import type { LocaleConfigResponseModelType } from 'container/modules/LocaleConfigFetcher/models/flow/LocaleConfigResponse';
import { LocaleConfig } from './LocaleConfig';

class InternalLocaleConfigResponse extends LocaleConfigResponse {
    static fromJS(
        json: LocaleConfigResponseModelType
    ): InternalLocaleConfigResponse {
        const state: Object = Object.assign({}, json);
        state.localeSettings = LocaleConfig.fromJS(state.localeSettings);
        return new this(Immutable.Map(state));
    }

    get localeSettings(): LocaleConfig {
        return this._state.get('localeSettings');
    }
}

export { InternalLocaleConfigResponse as LocaleConfigResponse };
